export type RecordingAction =
  | 'preparing'
  | 'starting'
  | 'started'
  | 'stopped'
  | 'failed'
  | 'cancelled';

export const RECORDING_EVENT_TYPE = 'recording-event';

export interface RecordingEventPayload {
  type: typeof RECORDING_EVENT_TYPE;
  action: RecordingAction;
  source?: 'server' | 'client';
  actorIdentity?: string | null;
  actorName?: string | null;
  queuePosition?: number;
  message?: string;
  timestamp: number;
}
